import React from "react";

import {UiState} from "../../../ui-state";

import {AppState} from "../../../../stores/app-mobx";
import {Icon} from "../../icon/icon";
import {ElevationProfileConfiguration} from "../../../config/tools-configuration";
import EsriElevationProfile from "@arcgis/core/widgets/ElevationProfile";
import ElevationProfileLineQuery from "@arcgis/core/widgets/ElevationProfile/ElevationProfileLineQuery";
import _ from "lodash";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import {autorun} from "mobx";

interface ElevationProfileProps {
    config?: ElevationProfileConfiguration | undefined;
    view: __esri.MapView | __esri.SceneView | undefined;
    uiStore: UiState;
    appStore: AppState;
    small?: boolean;
}

export class ElevationProfile extends React.Component<ElevationProfileProps, any> {
    watchHandles: any[] = [];
    autorunDisposers: any[] = [];
    elevationProfile: EsriElevationProfile;
    profileRef: any;
    widgetKey = "elevation-profile";
    constructor(props: ElevationProfileProps) {
        super(props);
        this.state = {
            active: false,
            isLoading: true,
            inProgress: false,
            state: ""
        };
        this.profileRef = React.createRef();
        if (typeof this.props.small === "boolean" && this.props.small) {
            this.widgetKey += "-small";
        }
        this.close = this.close.bind(this);
    }
    setActive(active: boolean): void {
        const {config, uiStore, view} = this.props;
        if (!view) {
            return;
        }
        if (active){
            if (!this.elevationProfile) {
                // settings und clear Button ausschalten falls nicht definiert
                if(config?.visibleElements){
                    if(!config?.visibleElements?.settingsButton) {
                        config.visibleElements.settingsButton = false;
                    }
                    if(!config?.visibleElements?.clearButton) {
                        config.visibleElements.clearButton = false;
                    }
                }
                let profiles: __esri.ElevationProfileLineQuery[] = [];
                view.map.ground.layers.forEach((l: __esri.ElevationLayer) => {
                    profiles.push(new ElevationProfileLineQuery({
                        id: l.id,
                        source: l,
                        title: l.title,
                        // Die Farben "green" und "orange" bereitet dem SDK V 4.28 probleme
                        color: (l.id === "dtm") ? "#aadd22" : "#ff7f00"
                    }));
                });
                profiles = _.orderBy(profiles, ["id"], ["desc"]);
                this.elevationProfile = new EsriElevationProfile({
                    container: this.profileRef.current,
                    view,
                    profiles,
                    unitOptions: ["metric", "meters", "kilometers"],
                    ...config as __esri.ElevationProfileProperties
                });
                this.watchHandles.push(
                    this.elevationProfile.watch("viewModel.progress", (newValue)=>{
                        let inProgress = false;
                        if(this.elevationProfile.viewModel.state === "selected"){
                            inProgress = newValue < 1;
                        }
                        // Der ViewModel "state" wird damit nicht zuverlässig aktualisiert. Dies wird jedoch nicht
                        // benötigt.
                        this.setState({
                            inProgress,
                            state: this.elevationProfile.viewModel.state
                        });
                    })
                );
            }
            this.elevationProfile.visible = true;
            if(uiStore.toolGraphic){
                if(this.elevationProfile.viewModel){
                    this.elevationProfile.viewModel.clear();
                }
                this.elevationProfile.input = uiStore.toolGraphic;
            }else if(!config?.visibleElements?.selectButton) {
                // Falls der Select Path Button deaktiviert ist, gleich den sketch Modus aktivieren.
                this.watchHandles.push(reactiveUtils.when(
                    () => this.elevationProfile.viewModel.state === "ready",
                    () => {
                        this.elevationProfile.viewModel.start();
                    },
                    { initial: true, once: true }
                ));
            }
        } else if(this.elevationProfile) {
            this.elevationProfile.viewModel.clear();
            this.elevationProfile.visible = false;
        }
    }
    close(): void {
        const {uiStore} = this.props;
        uiStore.PopupStore.setDisabled(false);
        uiStore.setActiveTool("");
    }
    componentDidMount(): void {
        autorun(() => {
            const {uiStore} = this.props;
            if (uiStore.activeTool === "profile") {
                this.setState({active: true});
                this.setActive(true);
            } else {
                this.setActive(false);
                this.setState({active: false});
            }
        });
    }
    componentWillUnmount(): void {
        const {uiStore, view} = this.props;
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
        this.autorunDisposers.forEach((disposer: any) => {
            disposer();
        });
        this.autorunDisposers.length = 0;
        if (view) {
            if (this.elevationProfile) {
                this.elevationProfile.destroy();
            }
        }
        uiStore.removeWidget(this.widgetKey);
    }

    render(): JSX.Element | null {
        const {active, inProgress, state} = this.state;
        return (
            <div className={"geo-profile-wrapper geo-widget geo-component"
                + (active? " show": " hidden") + (inProgress? " geo-widget-updating": "")
                + " geo-profile_state-" + state}>
                <div ref={this.profileRef} />
                <Icon name={"recycle"} className={"geo-rotating"}/>
                <Icon className={"geo-close"} name={"navigate_cross"} onClick={this.close} />
                <div className={"geo-elevation-info"}>Daten: Digitale Geländemodelle 2018</div>
            </div>
        );
    }
}
